import { render, staticRenderFns } from "./SellersView.vue?vue&type=template&id=6ac1ca9c"
import script from "./SellersView.vue?vue&type=script&lang=js"
export * from "./SellersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports